<script lang="ts">
  import type { FilterChipOptions, NextBestFilter } from "./type.ts";
  import { isActive } from "../../toggle/Toggle.ts";

  interface Props extends FilterChipOptions, NextBestFilter {}

  let { ref, title, itemCount, selected, fontSize = "75", onclick }: Props = $props();
</script>

{#if isActive("HEUREKA_1975_OC_CHIP_MIGRATION")}
  <oc-chip-v3 class={["hc_oc_chip", selected ? "hc_oc_chip--selected" : ""]} icon-right="arrow-down">
    <button data-ts-feature-ref={ref} type="button" {onclick}>
      <span class="hc_label hc_label--{fontSize}" data-count={itemCount}>
        <span class="hc_label__title">{title}</span>
      </span>
    </button>
  </oc-chip-v3>
{:else}
  <button class={["hc_chip", selected ? "hc_chip--selected" : ""]} data-ts-feature-ref={ref} type="button" {onclick}>
    <span class="hc_chip__handle">
      <span class="hc_label hc_label--{fontSize}" data-count={itemCount}>
        <span class="hc_label__title">{title}</span>
      </span>
      <oc-icon-v1 class="hc_chip--icon" type="arrow-down" size="50"></oc-icon-v1>
    </span>
  </button>
{/if}

<style lang="scss">
  .hc_oc_chip {
    --checked-font-weight: bold;

    white-space: nowrap;
    min-width: 59px;

    &--selected {
      .hc_label {
        font-weight: var(--checked-font-weight);
      }
    }
  }
  .hc_chip,
  .hc_oc_chip {
    --button-color: var(--oc-base-color-gray-25);
    --button-height: var(--oc-base-dimension-relative-32);
    --button-border-radius: calc(var(--button-height) / 2);
    --checkmark-size: var(--oc-base-dimension-relative-16);
    --checkmark-color-selected: var(--oc-semantic-color-text-default);
    --checked-hover-color: var(--oc-base-color-interactive-blue-lighten-35);
    --checked-font-weight: bold;
    --checked-color: var(--oc-base-color-interactive-blue-lighten-45);

    /*                                      */
    color: var(--oc-semantic-color-text-default);
    cursor: pointer;
    border: none;
    width: fit-content;
    height: var(--button-height);
    padding: 0 var(--oc-semantic-spacing-75);
    border-radius: var(--button-border-radius);

    &:not(&--selected) {
      background-color: var(--button-color);
    }

    &--selected {
      background-color: var(--checked-color);
      .hc_label__title {
        font-weight: var(--checked-font-weight);
      }
    }
    &__handle {
      display: flex;
      min-width: 59px;
      align-items: center;
      justify-content: center;
    }

    &--icon {
      margin-left: var(--oc-semantic-spacing-25);
    }

    .hc_label {
      white-space: nowrap;
      font: var(--label-font);
      &--50 {
        --label-font: var(--oc-semantic-font-copy-50);
      }

      &--75 {
        --label-font: var(--oc-semantic-font-copy-75);
      }

      &--100 {
        --label-font: var(--oc-semantic-font-copy-100);
      }

      &--125 {
        --label-font: var(--oc-semantic-font-copy-125);
      }
      &[data-count]::after {
        flex: 0 0 max-content;
        content: ": " attr(data-count);
        font-weight: var(--checked-font-weight);
      }
    }

    @media (hover: hover) {
      @at-root &:hover {
        background-color: var(--oc-base-color-black-lighten-71);

        &.hc_chip--selected {
          background-color: var(--checked-hover-color);
        }
      }
    }
  }
</style>
